import { GET_APPLY_PROPERTY, GET_APPLICATION_DETAILS } from "./actions";

const initialState = {
  appliedProperty: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  applicationDetails: {},
  applyPropertyLoading: true,
};

const appliedPropertyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_APPLY_PROPERTY:
      return {
        ...state,
        appliedProperty: payload,
        applyPropertyLoading: false,
      };
    case GET_APPLICATION_DETAILS:
      return {
        ...state,
        applicationDetails: payload,
        applyPropertyLoading: false,
      };
    default:
      return state;
  }
};

export default appliedPropertyReducer;
